<template>
    <TablesWrapper
        v-if="data"
        :loading="store.tableData.length === 0"
        :row-data="data"
        :col-defs
    />
</template>

<script lang="ts" setup>
import type { ColDef } from "ag-grid-community"
import EditRenderer from "~/components/EditRenderer.vue"

const store = useMainStore()

defineProps<{
    data: TableItem[] | undefined
}>()

const colDefs: ColDef[] = [
    {
        headerName: "OŘ",
        field: "MC_PRAHA",
        maxWidth: 100,
        resizable: false,
        sort: "asc",
        filter: true,
        floatingFilter: true,
    },
    {
        headerName: "Okrsek",
        field: "OKRSEK",
        maxWidth: 120,
        resizable: false,
        sort: "asc",
        comparator: (a: string | null, b: string | null) => {
            if (!a) return 1
            if (!b) return -1
            if (a === b) return 0
            if (!parseInt(a) && !parseInt(b)) return a.localeCompare(b)
            if (!parseInt(a)) return 1
            if (!parseInt(b)) return -1

            return parseInt(a) - parseInt(b)
        },
        filter: true,
        floatingFilter: true,
    },
    {
        headerName: "Příjmení a jméno",
        field: "OKRSKAR",
        width: 300,
        filter: true,
        floatingFilter: true,
    },
    {
        headerName: "Telefon",
        field: "TELEFON",
        width: 150,
        resizable: false,
    },
    {
        headerName: "Volací znak",
        field: "VOLACI_ZNAK",
        maxWidth: 200,
    },
    {
        headerName: "Okrsková služebna",
        field: "ADRESA_OKR",
        width: 350,
        filter: true,
        floatingFilter: true,
    },
    {
        headerName: "Telefon služebna",
        field: "TEL_USTREDNA",
        width: 150,
        resizable: false,
    },
    {
        headerName: "Úřední dny",
        field: "DEN",
    },
    {
        headerName: "Úřední hodiny",
        field: "HODINY",
    },
    {
        headerName: "Obvodní ředitelství",
        field: "OR_MP_PRAH",
    },
    {
        headerName: "Telefon obvodní ředitelství",
        field: "TEL_OR",
    },
    {
        headerName: "Telefon úřad MČ",
        field: "TELURAD",
        width: 150,
        resizable: false,
    },
    {
        cellRenderer: "EditRenderer",
        maxWidth: 50,
        resizable: false,
        cellStyle: { padding: 0 },
    },
    /* {
        cellRenderer: "DeleteRenderer",
        maxWidth: 50,
        resizable: false,
        cellStyle: { padding: 0 },
    }, */
]

/* function onClick() {
    console.log("Button clicked!")
} */

defineExpose({
    EditRenderer,
})
</script>

<style scoped></style>
